import { HeaderTextColor, ParagraphTextColor, primaryFont, isUrl } from "utils";
import { PrimaryButton } from "components";
// import { useHistory } from "react-router-dom";
import "./styles.scss";
import styled from "styled-components";
const Container = styled.div`
  padding: 0 ${(props) => (props.padding ? 0.5 : 0)}rem;
  .product__card__info {
    .product__card__price {
      color: ${(props) => props.theme.productCard.color};
      letter-spacing: 1px;
    }
  }
  .tag__is__offer {
    background-color: ${(props) => props.theme.productCard.color};
    color: #fff;
    font-family: ${primaryFont};
  }
`;

export const ProductCard = ({
  product,
  buttonText,
  onClick,
  padding = true,
}) => {
  return (
    <Container className="product__card" padding={padding}>
      <div className="product__card__content">
        <div className="product__card__image">
          <img
            src={
              product.image
                ? product.image
                : "https://via.placeholder.com/350x150?text=No+Image"
            }
            alt=""
          />
          {product?.isOffer && (
            <div className="tag__is__offer">
              <span>Oferta</span>
            </div>
          )}
        </div>

        <div className="product__card__info">
          <PrimaryButton
            className="product__card__button"
            modifiers={["small"]}
            onClick={onClick}
          >
            {buttonText}
          </PrimaryButton>

          <HeaderTextColor modifiers={["h4"]} className="product__card__price">
            Desde $ {product?.price} {product.typeCurrency || "(Sin moneda)"}
          </HeaderTextColor>
          <ParagraphTextColor className="product__card__title">
            {product?.destiny}
          </ParagraphTextColor>
          <ParagraphTextColor className="product__card__duration">
            {product?.duration} días
          </ParagraphTextColor>
        </div>
      </div>
    </Container>
  );
};
const ContainerHotel = styled.div`
  .hotel__info__full {
    border: 1px solid ${(props) => props.theme.form.borderColor};
  }
`;
export const HotelCard = ({ hotel, onClick }) => {
  return (
    <ContainerHotel className="hotel__card">
      <div className="hotel__image" onClick={onClick}>
        <img
          src={
            hotel.image
              ? hotel.image
              : "https://via.placeholder.com/350x150?text=No+Image"
          }
          alt=""
        />
      </div>
      <div className="hotel__info">
        <div className="hotel__name">
          <HeaderTextColor modifiers={["h5"]}>{hotel?.name}</HeaderTextColor>
        </div>
        <div className="hotel__location">
          <ParagraphTextColor>{hotel?.address}</ParagraphTextColor>
        </div>
      </div>
    </ContainerHotel>
  );
};

export const HotelCardFull = ({ hotel }) => {
  return (
    <ContainerHotel className="hotel__card">
      <div className="hotel__image">
        <img
          src={
            hotel?.image
              ? hotel?.image
              : "https://via.placeholder.com/350x150?text=No+Image"
          }
          alt=""
        />
      </div>
      <>
        <div className="hotel__info__full">
          <div className="hotel__name">
            <HeaderTextColor modifiers={["h5"]}>{hotel?.name}</HeaderTextColor>
          </div>
          <div className="hotel__location">
            <ParagraphTextColor>Dirección {hotel?.address}</ParagraphTextColor>
          </div>
          <div className="hotel__phone">
            <ParagraphTextColor>Tel. {hotel?.phone}</ParagraphTextColor>
          </div>
          <div className="hotel__email">
            <a href={`mailto:${hotel?.email}`}>
              <ParagraphTextColor>{hotel?.email}</ParagraphTextColor>
            </a>
          </div>
          <div className="hotel__description">
            <ParagraphTextColor
              dangerouslySetInnerHTML={{ __html: hotel?.description }}
            />
          </div>
          <div className="hotel__price">
            <ParagraphTextColor>Desde ${hotel?.price} MXN</ParagraphTextColor>
          </div>
          {isUrl(hotel?.website) && (
            <div className="hotel__button">
              <a
                href={`${hotel?.website}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PrimaryButton modifiers={["small"]}>Ver más</PrimaryButton>
              </a>
            </div>
          )}
        </div>
      </>
    </ContainerHotel>
  );
};
